export const toCamelCase = (str: string) => {
  const tempStr = str.split(" ");
  return tempStr.map((item) => item[0].toUpperCase() + item.slice(1)).join(" ");
};

export const isOnlyCountryCode = (value: any, country: any) => {
  // Remove all non-digit except +
  const digits = value.replace(/[^\d+]/g, "");
  // Compare with country code
  return digits === `+${country.dialCode}`;
};
